import React from "react";
//import {path, compose, curry} from 'ramda';
//import * as Maybe from 'folktale/maybe'

/**
 * Контекст пользователя для доступа к состоянию аутентификации.
 * @type {React.Context}
 */
export const UserContext = React.createContext();

/**
 * Перечень экшенов редьюсера аутентификации.
 * @readonly
 * @enum {string}
 */
export const AUTH=Object.freeze({
    LOGIN:'LOGIN',
    LOGOUT:'LOGOUT',
    PENDING: 'PENDING',
    REJECT:'REJECT',
    PROJECT:'PROJECT',
    DATE:'DATE'
})

/**
 * Возможные состояния процесса логина.
 * @readonly
 * @enum {string}
 */
export const LOG_STATE=Object.freeze({
    UNLOGGED: 'Unlogged',
    PENDING:  'Pending',
    REJECTED: 'Rejected',
    SETTLED:  'Settled'
})


/**
 * Начальное состояние пользователя и процесса аутентификации.
 * @type {Object}
 * @property {?Object} user - Текущий пользователь.
 * @property {?Date} authDate - Дата последней успешной аутентификации.
 * @property {string} status - Текущее состояние входа.
 * @property {?Error} error - Последняя ошибка аутентификации.
 * @property {Date} date - Текущая дата (служебное поле).
 * @property {?Object} project - Текущий проект (опционально).
 */
export const initialState = {
    user: null,
    authDate: null, //время аутентификации (для ограничения времени сессии)
    status: LOG_STATE.UNLOGGED,//Unlogged, Pending, Rejected, Settled
    error: null, 
    date: new Date(),
    project: null,//Maybe.Nothing()
};

/**
 * Редьюсер для управления состоянием аутентификации.
 * @param {Object} state - Текущее состояние.
 * @param {Object} action - Действие редьюсера.
 * @param {string} action.type - Тип действия из AUTH.
 * @param {Object} [action.payload] - Дополнительные данные.
 * @returns {Object} Новое состояние.
 */
export const userReducer = (state, action) => {
    switch(action.type) {
        case AUTH.LOGIN: return {...state, user: action.payload?.user, authDate: new Date(), status: 'Settled', error:null};
        case AUTH.LOGOUT: return initialState;//{...state, user: null, project: Maybe.Nothing(), status: 'Unlogged', error:null // TODO - м.б. сделать просто initialState?};
        case AUTH.PENDING: return {...state, status: LOG_STATE.PENDING, error: null};
        case AUTH.REJECT: return {...state, user: null, status: LOG_STATE.REJECTED, error: action.payload?.error};
        case AUTH.PROJECT: return {...state, project: action.payload?.project}; //TODO не используется?
        case AUTH.DATE: return {...state, date: new Date(action.payload?.date)}; //TODO не используется?
        default: return state;
    }
};
